import { useState, useEffect } from 'react';
import { AlarmsService } from 'src/services/alarms';
import { Notification } from 'src/features/alarm-pop-up/types';

type Props = {
  customerId?: string;
  eventId?: string;
  isOpen: boolean;
};

export const useGetAlarmPopupNotifications = ({ customerId, eventId, isOpen }: Props) => {
  const [notifications, setNotifications] = useState<Notification[] | []>([]);

  useEffect(() => {
    if (!customerId || !eventId || !isOpen) return;
    const getNotifications = async () => {
      try {
        const response = await AlarmsService.getAlarmPopupNotifications(customerId, eventId);
        setNotifications(response);
      } catch (error) {
        console.error(error);
      }
    };
    getNotifications();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerId, eventId, isOpen]);

  return { notifications };
};
